export const contact = process.env.REACT_APP_CONTACT??"laurent.laluque@digital4better.com"